import React from 'react';
import LineGraph from '../../events-line/LineGraph';
import Select from 'react-select'
import './performance-statistics.css'


const PerformanceStatistics = (props) => {
    console.log('veio', props.data)
    const data = {
        labels: props.data.meses,
        datasets: [
          {
            label: props.data.option1.label,
            data: props.data.option1.value,
            fill: false,
            backgroundColor: '#AFACFB',
            borderColor: '#AFACFB',
          },
          {
            label: props.data.option2.label,
            data: props.data.option2.value,
            fill: false,
            backgroundColor: '#5AD9FF',
            borderColor: '#5AD9FF',
          },
        ],
      }

    return (
        <div className='performance-statistics'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }} className="performance-statistics-header">
                <span className="movimentation-graph-title">{props.title || 'Estatísticas e Desempenho'}</span>
                <div style={{ width: '200px', marginRight: '10px' }}>
                    <Select
                        placeholder="Mês"
                        options={props.options}
                        closeMenuOnSelect={true}
                        onChange={props._handle}
                        defaultValue={props.defaltEstrategicValue}
                    />

                </div>
            </div>

            <LineGraph data={data}/>

        </div>
    )

};

export default PerformanceStatistics;